import React from 'react';
import Button from '@mui/material/Button';


function Apply({onApplyClick, applyChanges }) {
  const isButtonEnabled = (applyChanges === true);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <Button
        style={{ width: '422px' }}
        variant="contained"
        color="primary"
        disabled={!isButtonEnabled}
        onClick={onApplyClick}
      >
        Apply Changes
      </Button>
    </div>
  );
}

export default Apply;